import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const createFactoringRequest = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/factoring/request`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const checkFactoringRequestDeletion = async (
  dispatch: Dispatch,
  id: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/factoring/request/${id}/checkDelete`,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteFactoringRequest = async (dispatch: Dispatch, id: any) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/factoring/request/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateStatusFactoringRequest = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/factoring/request/${id}/updateStatus`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const editParamsOnReview = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/factoring/request/${id}/inReview/editParams`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const editQuoteComitee = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/factoring/quote/${id}/comitee`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const editOperationsQuoteComitee = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/factoring/quote/${id}/comitee/operation`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteQuoteApproval = async (
  dispatch: Dispatch,
  id: number,
  approvalId: any,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/factoring/quote/${id}/approval/${approvalId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getQuoteApprovals = async (dispatch: Dispatch, id: number) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/factoring/quote/${id}/approval`,
    dispatch,
  });
  if (response) return response.data;
};

export const addOwnCompanyConfirmationsToDocuments = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/users/factoring/documents/addOwnConfirmation`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const addExtraDataToDocument = async (
  dispatch: Dispatch,
  data: {
    documents: any[];
    attributes: string[];
  },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/users/factoring/documents/addExtraData`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const activateNullFactoringRequest = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/factoring/request/${id}/payments/activateNull`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getAvailableArrearTables = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/factoring/arrearTables`,
    dispatch,
  });
  if (response) return response.data;
};

export const getReplacementInvoices = async (
  dispatch: Dispatch,
  documentId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/factoring/replacementInvoices/${documentId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const replaceInvoice = async (
  dispatch: Dispatch,
  data: any,
  documentId: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/factoring/replaceInvoice/${documentId}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getExecutivesAvailableForFactoring = async (
  dispatch: Dispatch,
  businessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/factoring/executivesAvailable/${businessIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const editExecutive = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/users/factoring/executive`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getLastActiveQuote = async (
  dispatch: Dispatch,
  businessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/factoring/lastActiveQuote/${businessIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};
